import styles from "./sparkline.module.scss";

interface SparklineProps {
  values: number[];
  width?: number;
  height?: number;
}

export function Sparkline({ values, width = 42, height = 16 }: SparklineProps) {
  if (values.length === 0) return null;

  const barCount = values.length;
  const gap = 2;
  const barWidth = Math.max(2, (width - gap * (barCount - 1)) / barCount);
  const maxVal = Math.max(...values, 0.01);

  return (
    <svg width={width} height={height} className={styles.sparkline} aria-hidden="true">
      {values.map((val, i) => {
        const barHeight = Math.max(1, (val / maxVal) * height);
        const x = i * (barWidth + gap);
        const y = height - barHeight;
        const isLast = i === values.length - 1;

        return (
          <rect
            key={i}
            x={x}
            y={y}
            width={barWidth}
            height={barHeight}
            rx={1}
            className={isLast ? styles.barAccent : styles.bar}
          />
        );
      })}
    </svg>
  );
}
